export default "__VITE_ASSET__BzAVkQ81__"